import ProductCard from './ProductCard';
import type { ProductSummary } from '@/types/product';

interface ProductGridProps {
  products: ProductSummary[];
  loading?: boolean;
}

function SkeletonCard() {
  return (
    <div className="bg-white rounded-2xl overflow-hidden border border-[#f0ebe4] flex flex-col animate-pulse">
      <div className="h-56 bg-[#f5f0eb]"></div>
      <div className="p-5 flex flex-col gap-3">
        <div className="h-4 w-16 bg-[#f0ebe4] rounded-full"></div>
        <div className="h-5 w-3/4 bg-[#f0ebe4] rounded"></div>
        <div className="h-4 w-full bg-[#f0ebe4] rounded"></div>
        <div className="h-4 w-2/3 bg-[#f0ebe4] rounded"></div>
        <div className="mt-2 flex justify-between items-center pt-4 border-t border-[#f5f0eb]">
          <div className="h-6 w-16 bg-[#f0ebe4] rounded"></div>
          <div className="w-9 h-9 rounded-full bg-[#f0ebe4]"></div>
        </div>
      </div>
    </div>
  );
}

export default function ProductGrid({ products, loading = false }: ProductGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
        {Array.from({ length: 6 }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#f5f0eb] mb-4">
          <i className="ri-search-line text-2xl text-[#C8714A]"></i>
        </div>
        <p className="text-[#888] text-base font-medium mb-2">暂无该分类产品</p>
        <p className="text-[#bbb] text-sm">请尝试其他分类</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
      {products.map((product, index) => (
        <ProductCard key={product.id} product={product} index={index} />
      ))}
    </div>
  );
}
